import React from "react";
import "./LandingHero.css";

export default function LandingContent() {
  return (
    <>
      {/* INTRO SECTION */}
      <section className="ds-intro">
        <div className="ds-intro-left">
          <p className="ds-intro-tag">Dental care, reimagined.</p>
          <h2 className="ds-intro-title">
            Expert Dental Care,
            <br /> At The Heart Of The City,
            <br/>Your Best Dental Clinic in Guwahati.
          </h2>
        </div>

        <div className="ds-intro-right">
          <p>
            At PrimeMax, Guwahati's most trusted dental clinic, we combine advanced technology with a calm, design–
            driven space to make every visit feel effortless. From preventive
            care and cosmetic treatments to complex restorative work, our team
            focuses on comfort, clarity, and long-term oral health.
          </p>

          <p>
            Whether it’s your first check-up in years or a full smile makeover,
            we create a treatment plan around you — not the other way around.
          </p>
        </div>
      </section>

      {/* OPENING HOURS SECTION */}
      <section className="ds-hours">
        {/* <h2 className="ds-hours-title">Opening Hours</h2> */}

        <div className="ds-hours-box">
          <div className="ds-hours-item">
            <div className="ds-hours-number">01</div>
            <div>
              <p className="ds-hours-label">Monday – Saturday</p>
              <p className="ds-hours-time">10:00 AM – 8:30 PM</p>
            </div>
          </div>

          <div className="ds-hours-item">
            <div className="ds-hours-number">02</div>
            <div>
              <p className="ds-hours-label">Sunday</p>
              <p className="ds-hours-time">10:00 AM – 6:00 PM</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
